import {
  getColumnIndex,
} from '../../../../components/gsheet';

export default function deleteGene(rawDataCollection, table_header, rows) {
  const gene_uuid_index = getColumnIndex(table_header, 'Gene ID');
  const gene_uuid_list = rows.map((row) => (row[gene_uuid_index]));
  const gene_uuid_set = new Set(gene_uuid_list);

  const {rawSequenceMap, rawAlignments, rawSequences} = rawDataCollection;

  let deletedAlign = [];
  let deletedSeq = [];

  for (const alignedSeq of rawAlignments) {
    const rawSeqUUID = alignedSeq.rawSequenceUuid;
    let rawSequence = rawSequenceMap[rawSeqUUID];
    const geneSequences = alignedSeq.geneSequences;

    const reservedGenes = geneSequences.filter((gene) => {
      return gene_uuid_set.has(gene.uuid);
    });
    const deletedGenes = geneSequences.filter((gene) => {
      return !gene_uuid_set.has(gene.uuid);
    });

    if (reservedGenes.length === 0) {
      deletedAlign.push(alignedSeq.uuid);
      deletedSeq.push(rawSequence.uuid);
    } else {
      alignedSeq.geneSequences = reservedGenes;
    }
    if (deletedGenes.length > 0) {
      rawSequence = chopSequence(rawSequence, deletedGenes);
    }
  }

  rawDataCollection.rawAlignments = rawAlignments.filter(
    (alignedSeq) => !deletedAlign.includes(alignedSeq.uuid));
  rawDataCollection.rawSequences = rawSequences.filter(
    (seq) => !deletedSeq.includes(seq.uuid));
}

function chopSequence(rawSequence, deletedGenes) {
  const originalSeq = rawSequence.sequence;
  for (const delGene of deletedGenes) {
    if (originalSeq.includes(delGene.alignedNAs)) {
      rawSequence.sequence = originalSeq.replace(delGene.alignedNAs, '');
    } else {
      rawSequence.sequence = originalSeq.replace(delGene.alignedAAs, '');
    }
  }
  return rawSequence;
}


export function deleteSeq(rawDataCollection, table_header, rows) {
  const seq_uuid_index = getColumnIndex(table_header, 'Sequence ID');
  const seq_uuid_list = rows.map((row) => (row[seq_uuid_index]));
  const seq_uuid_set = new Set(seq_uuid_list);

  const {rawAlignments, rawSequences} = rawDataCollection;

  let reservedAlignedSeq = new Set();

  for (const alignedSeq of rawAlignments) {
    const rawSeqUUID = alignedSeq.rawSequenceUuid;

    if (seq_uuid_set.has(rawSeqUUID)) {
      reservedAlignedSeq.add(alignedSeq.uuid);
    }
  }

  rawDataCollection.rawAlignments = rawAlignments.filter(
    (alignedSeq) => reservedAlignedSeq.has(alignedSeq.uuid));
  rawDataCollection.rawSequences = rawSequences.filter(
    (seq) => seq_uuid_set.has(seq.uuid));

  return rawDataCollection;
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/gtable_seq/delete-gene.js